export const courses = [
	{
		title: 'Consulting Interview Preparation (For Undergraduates)',
		content: {
			playlists: [
				{
					title: 'CIC: Learn the Basic Concepts',
					videos: [
						{
							title: 'Session #1 - Introduction to Case Interviews',
							link: 'https://youtu.be/6eKf3AArVbg',
						},
						{
							title: 'Session #2 - Guesstimates',
							link: 'https://youtu.be/m0vNtHKRNaA',
						},
						{
							title: 'Session #3 - Profitability Cases',
							link: 'https://youtu.be/OBSntqz0XhA',
						},
						{
							title: 'Session #4 - Market Entry Cases',
							link: 'https://youtu.be/m7hNx4xMiFg',
						},
					],
				},
				{
					title: 'CIC: Mock Interview Series',
					videos: [
						{
							title: '#1 McDonalds Guesstimate 1',
							link: 'https://youtu.be/4ttxod7nZbY',
						},
						{
							title: '#2 McDonalds Guesstimate 2',
							link: 'https://youtu.be/fJFvapYo3QU',
						},
						{
							title: '#3 Laptops Guesstimate 1',
							link: 'https://youtu.be/fPyI00hr1Tw',
						},
						{
							title: '#4 Laptops Guesstimate 2',
							link: 'https://youtu.be/sy2h0sRpVvA',
						},
						{
							title: '#5 Hotel Profitability 1',
							link: 'https://youtu.be/nFhqCXidTy8',
						},
						{
							title: '#6 Electronics Profitability 1',
							link: 'https://youtu.be/cXNg0gaT75w',
						},
						{
							title: '#7 Electronics Profitability 2',
							link: 'https://youtu.be/dWU0stf_CCE',
						},
						{
							title: '#8 Electronics Profitability 3',
							link: 'https://youtu.be/bGprepeszUI',
						},
						{
							title: '#9 Petrol Pump Profitability 1',
							link: 'https://youtu.be/XBdY5Kcwcac',
						},
						{
							title: '#10 Solar Lantern 1 | Market Entry',
							link: 'https://youtu.be/4XJ2H4seD9I',
						},
						{
							title: '#11 Solar Lantern 2 | Market Entry',
							link: 'https://youtu.be/5RhqadzWsLg',
						},
						{
							title: '#12 Solar Lantern 3 | Market Entry',
							link: 'https://youtu.be/pk0U5VIugWY',
						},
						{
							title: '#13 Petrol Pump Profitability 2',
							link: 'https://youtu.be/dmBMuwh8KaA',
						},
						{
							title: '#14 Petrol Pump Profitability 3',
							link: 'https://youtu.be/OGoePOj-nTw',
						},
						{
							title: '#15 Travel time Unconventional 1',
							link: 'https://youtu.be/W7gaSDFA5ag',
						},
						{
							title: '#16 Travel time Unconventional 2',
							link: 'https://youtu.be/EjWVRdW_-EA',
						},
						{
							title: '#17 T Rex Unconventional 1',
							link: 'https://youtu.be/Dkk1LfP8v7Y',
						},
						{
							title: '#18 T Rex Unconventional 2',
							link: 'https://youtu.be/MmCImF3ap84',
						},
					],
				},
				{
					title: 'Guesstimate Videos',
					videos: [
						{
							title: 'No. of trains in the Delhi metro network',
							link: 'https://youtu.be/7XFlVi6v4bU',
						},
						{
							title: 'o of flights out of Delhi in a day?',
							link: 'https://youtu.be/ILUWBewGes0',
						},
						{
							title: 'Area of India?',
							link: 'https://youtu.be/frWnS2fCoHw',
						},
						{
							title: 'Estimating the area of Delhi',
							link: 'https://youtu.be/SuIt-hGXNGs',
						},
					],
				},
				{
					title: '(Optional) Victor Cheng: Case Interview Workshop',
					videos: [
						{
							title: '#1 Introduction',
							link: 'https://youtu.be/fBwUxnTpTBo',
						},
						{
							title: '#2 Basics & Case Interviewer Mindset',
							link: 'https://youtu.be/h0e32s1vyt4',
						},
						{
							title: '#3 How to Open, Analyze and Close a Case Interview - Part 1',
							link: 'https://youtu.be/3iwZD_1Q0Jk',
						},
						{
							title: '#4 How to Open, Analyze and Close a Case Interview - Part 2',
							link: 'https://youtu.be/3hTag-2Qr8Q',
						},
						{
							title: '#5 Matching Case Interviews to Problem Solving Frameworks',
							link: 'https://youtu.be/L8xIcvpNOSw',
						},
						{
							title: '#6 Case Interview Profit Framework ',
							link: 'https://youtu.be/jtvyRnmkDqo',
						},
						{
							title: '#7 Business Situation Case Interview Framework',
							link: 'https://youtu.be/lhQvl0wo6Fs',
						},
						{
							title: '#8 How to Practice Case Interviews',
							link: 'https://youtu.be/huqJ4wZ-asY',
						},
						{
							title: '#9 Business Situation Case Interview Demo',
							link: 'https://youtu.be/D-QlFzg_1EA',
						},
						{
							title: '#10 Case Interview Question & Answers',
							link: 'https://youtu.be/xAxnHVaVSlA',
						},
						{
							title: '#11 Mergers and Acquisition Case Interview Demo',
							link: 'https://youtu.be/_bmodEjtvnQ',
						},
						{
							title: '#12 Case Interview Tips',
							link: 'https://youtu.be/gRUvbrOtd-c',
						},
					],
				},
			],
			pdfs: [
				{
					title: 'The Guesstimate',
					link: 'https://drive.google.com/file/d/1_XCEaujBto7dX62ol_qyXWgb0fBMiY0c/view?usp=sharing',
				},
				{
					title: 'Guesstimate Questions Set',
					link: 'https://drive.google.com/file/d/1ufnjK76dM0vE52YL7gcktqQ37d0S2S1i/view?usp=sharing',
				},
				{
					title: 'Case Interview Cracked (IIT Case Book)',
					link: 'https://drive.google.com/file/d/1dyTrYbkVQW0ZjRbwU-t5xuiMwkmLid1G/view?usp=sharing',
				},
				{
					title: '(Optional) Puzzles',
					link: 'https://drive.google.com/file/d/1jKrhNaYrydLaX7EEJ6wJC9eFcUzQvIJR/view?usp=sharing',
				},
				{
					title: '(Optional) Case In Point',
					link: 'https://drive.google.com/file/d/1O9-uvYG9-EOwRz-SbS2-ycjzZXqBwo2S/view?usp=sharing',
				},
				{
					title: '(Optional) Case Interview Frameworks',
					link: 'https://drive.google.com/file/d/1hfj_JLvMyOeZsSQIbm7AJty4XSlSgUba/view?usp=sharing',
				},
				{
					title: '(Optional) Vault Guide to Case Interview [Deloitte, ZS]',
					link: 'https://drive.google.com/file/d/10WPh3SotZQJDPmVkutO-V4cc1OCEHDN9/view?usp=sharing',
				},
				{
					title: 'IFSA - The Undergraduate Case Interview Handbook',
					link: 'https://drive.google.com/file/d/1-Z2r5spa8fVZvlOYvaWT0tVQNLEdQbHf/view?usp=sharing',
				},
				
			],
			articles: [],
		},
	},
	{
	title: 'Mastering the Case: Interview Case Study Prep',
		content: {
			playlists: [
				{
					title: 'CIC: Learn the Basic Concepts',
					videos: [
						{
							title: '#1 - Introduction to Case Interviews',
							link: 'https://youtu.be/6eKf3AArVbg',
						},
						{
							title: '#2 - Profitability Cases',
							link: 'https://youtu.be/OBSntqz0XhA',
						},
						{
							title: '#3 - Market Entry Cases',
							link: 'https://youtu.be/m7hNx4xMiFg',
						},
					],
				},
				{
					title: 'CIC: Mock Interview Series',
					videos: [
						{
							title: '#1 Hotel Profitability 1',
							link: 'https://youtu.be/nFhqCXidTy8',
						},
						{
							title: '#2 Electronics Profitability 1',
							link: 'https://youtu.be/cXNg0gaT75w',
						},
						{
							title: '#3 Electronics Profitability 2',
							link: 'https://youtu.be/dWU0stf_CCE',
						},
						{
							title: '#4 Electronics Profitability 3',
							link: 'https://youtu.be/bGprepeszUI',
						},
						{
							title: '#5 Petrol Pump Profitability 1',
							link: 'https://youtu.be/XBdY5Kcwcac',
						},
						{
							title: '#6 Solar Lantern 1 | Market Entry',
							link: 'https://youtu.be/4XJ2H4seD9I',
						},
						{
							title: '#7 Solar Lantern 2 | Market Entry',
							link: 'https://youtu.be/5RhqadzWsLg',
						},
						{
							title: '#8 Solar Lantern 3 | Market Entry',
							link: 'https://youtu.be/pk0U5VIugWY',
						},
						{
							title: '#9 Petrol Pump Profitability 2',
							link: 'https://youtu.be/dmBMuwh8KaA',
						},
						{
							title: '#10 Petrol Pump Profitability 3',
							link: 'https://youtu.be/OGoePOj-nTw',
						},
						{
							title: '#11 Travel time Unconventional 1',
							link: 'https://youtu.be/W7gaSDFA5ag',
						},
						{
							title: '#12 Travel time Unconventional 2',
							link: 'https://youtu.be/EjWVRdW_-EA',
						},
						{
							title: '#13 T Rex Unconventional 1',
							link: 'https://youtu.be/Dkk1LfP8v7Y',
						},
						{
							title: '#14 T Rex Unconventional 2',
							link: 'https://youtu.be/MmCImF3ap84',
						},
					],
				},
				{
					title: 'Victor Cheng: Case Interview Workshop',
					videos: [
						{
							title: '#1 Introduction',
							link: 'https://youtu.be/fBwUxnTpTBo',
						},
						{
							title: '#2 Basics & Case Interviewer Mindset',
							link: 'https://youtu.be/h0e32s1vyt4',
						},
						{
							title: '#3 How to Open, Analyze and Close a Case Interview - Part 1',
							link: 'https://youtu.be/3iwZD_1Q0Jk',
						},
						{
							title: '#4 How to Open, Analyze and Close a Case Interview - Part 2',
							link: 'https://youtu.be/3hTag-2Qr8Q',
						},
						{
							title: '#5 Matching Case Interviews to Problem Solving Frameworks',
							link: 'https://youtu.be/L8xIcvpNOSw',
						},
						{
							title: '#6 Case Interview Profit Framework ',
							link: 'https://youtu.be/jtvyRnmkDqo',
						},
						{
							title: '#7 Business Situation Case Interview Framework',
							link: 'https://youtu.be/lhQvl0wo6Fs',
						},
						{
							title: '#8 How to Practice Case Interviews',
							link: 'https://youtu.be/huqJ4wZ-asY',
						},
						{
							title: '#9 Business Situation Case Interview Demo',
							link: 'https://youtu.be/D-QlFzg_1EA',
						},
						{
							title: '#10 Case Interview Question & Answers',
							link: 'https://youtu.be/xAxnHVaVSlA',
						},
						{
							title: '#11 Mergers and Acquisition Case Interview Demo',
							link: 'https://youtu.be/_bmodEjtvnQ',
						},
						{
							title: '#12 Case Interview Tips',
							link: 'https://youtu.be/gRUvbrOtd-c',
						},
					],
				},
			],
			pdfs: [
				{
					title: 'Case Interview Cracked (IIT Case Book)',
					link: 'https://drive.google.com/file/d/1dyTrYbkVQW0ZjRbwU-t5xuiMwkmLid1G/view?usp=sharing',
				},
				{
					title: 'Case In Point',
					link: 'https://drive.google.com/file/d/1O9-uvYG9-EOwRz-SbS2-ycjzZXqBwo2S/view?usp=sharing',
				},
				{
					title: 'Case Interview Frameworks',
					link: 'https://drive.google.com/file/d/1hfj_JLvMyOeZsSQIbm7AJty4XSlSgUba/view?usp=sharing',
				},
				{
					title: 'Vault Guide to Case Interview [Deloitte, ZS]',
					link: 'https://drive.google.com/file/d/10WPh3SotZQJDPmVkutO-V4cc1OCEHDN9/view?usp=sharing',
				},
				{
					title: 'Casebook IIM Ahmedabad (2013)',
					link: 'https://drive.google.com/file/d/1IuOifl0KCiaR0sBzqVQi42QdL2ooCSbH/view?usp=sharing',
				},
				{
					title: 'Casebook IIM Bangalore (2022-23)',
					link: 'https://drive.google.com/file/d/1zMgtbWAFJLeXkYDpat_faWfLwcYRlB3v/view?usp=sharing',
				},
				{
					title: 'Casebook IIM Calcutta (2022-23)',
					link: 'https://drive.google.com/file/d/19ymbHs_OtMcAdrAgq5VCRKKcWmo54OOg/view?usp=sharing',
				},
				{
					title: 'The FMS consulting casebook (2021-22)',
					link: 'https://drive.google.com/file/d/14z9PqW64rtIHANUBQ1jpFmOT-N33A45A/view?usp=sharing',
				},
				{
					title: 'BCG - ESADE Casebook',
					link: 'https://drive.google.com/file/d/16bZFxq4T1XdlD2SeLidr6S9K5mQ2XiMM/view?usp=sharing',
				},
				{
					title: 'Case Interview Guide - Harvard Business School',
					link: 'https://drive.google.com/file/d/15iy2dJ-8TX-OtfzpZsA-xNzSg8gkdIyR/view?usp=sharing',
				},
				{
					title: 'Case Interview Guide - McCombs School of Business',
					link: 'https://drive.google.com/file/d/1TBPhJEqRqpPvFyCT5qXAOD9Wws4uB52W/view?usp=sharing',
				},
				{
					title: 'Case Interview Frameworks',
					link: 'https://drive.google.com/file/d/1Pid59PhPJyR02bNN-NI_1JsQK7u4lYQF/view?usp=sharing',
				},
				{
					title: 'Casebook - Duke - The FUQUA School of Business',
					link: 'https://drive.google.com/file/d/19uF5Vx9bM0zPAfEK8mV23ncV86wij4BS/view?usp=sharing',
				},
				{
					title: 'IIMA Consult Prep Book (2020-21)',
					link: 'https://drive.google.com/file/d/1OwPkXmfbjWysY17HMGEmUt3p4gOTchlU/view?usp=sharing',
				},
				{
					title: 'IIMC Casebook (2020-21)',
					link: 'https://drive.google.com/file/d/1oxozUXgXE1m6EKVBYoWRCRdv6XLTWNKF/view?usp=sharing',
				},
				{
					title: 'IIMB Casebook (2020-21)',
					link: 'https://drive.google.com/file/d/1jgoFEsFaJs_VZmE4xLTsCArDEmmY7a9W/view?usp=sharing',
				},
				{
					title: 'ISB Consulting Casebook (2020)',
					link: 'https://drive.google.com/file/d/18mq5Oh2UwXnKWh3hAqo-wQwmnqr-fvNl/view?usp=sharing',
				},
				{
					title: 'Wharton Consulting Club Casebook (2017)',
					link: 'https://drive.google.com/file/d/1iVaBBAWW9Gn0bePc1o7PN70Souad6cc4/view?usp=sharing',
				},
				{
					title: 'Casebook XLRI (2022)',
					link: 'https://drive.google.com/file/d/1CNBUMjUKwnJCxWZuHQsb08-ZIhzPAxoW/view?usp=sharing',
				},
				{
					title: 'Casebook XLRI (2020)',
					link: 'https://drive.google.com/file/d/1wQtONBpxzYx5I1Jah_1EVisEmky4z3ri/view?usp=sharing',
				},
				{
					title: 'IFSA - The Undergraduate Case Interview Handbook',
					link: 'https://drive.google.com/file/d/1-Z2r5spa8fVZvlOYvaWT0tVQNLEdQbHf/view?usp=sharing',
				},
				{
					title: 'Victor Cheng - Case interview secrets',
					link: 'https://drive.google.com/file/d/1EMC9L092bwdHvgN5V5vp_qmYtRhVNupX/view?usp=sharing',
				},
				{
					title: 'The Mckinsey Way',
					link: 'https://drive.google.com/file/d/1TdQ2-Mgljuq6R9zdQwQGReI8uVHXOmVI/view?usp=sharing',
				},
				{
					title: 'NYU Casebook 2018',
					link: 'https://drive.google.com/file/d/1s4ZH207BA3IVEvmV6giWOb13iMDwKUjb/view?usp=sharing',
				},
				{
					title: 'MIT Sloan Case book',
					link: 'https://drive.google.com/file/d/18OYSeB1sHUD0-84zOiHFq6_LAjPOLh6z/view?usp=sharing',
				},
				{
					title: 'IIM Lucknow Casebook 2021',
					link: 'https://drive.google.com/file/d/1jswTX5V1CGKkv5YeXnME4h4nm1bbXOhQ/view?usp=sharing',
				},
				{
					title: 'AT Kearney Consulting Casebook',
					link: 'https://drive.google.com/file/d/1tJ59sse8LOfAVZAeRGO65U-KKnTS0Etq/view?usp=sharing',
				},
				
			],
			articles: [],
		},
	},
	{
	title: 'The Winning Edge: Crafting Captivating Case Study Decks',
		content: {
			playlists: [],
			pdfs: [
				{
					title: 'Accenture B school challenge problem statement',
					link: 'https://drive.google.com/file/d/1yoPKWzE3Dx5twaXu3oHm7ISNgAmOjMJX/view?usp=sharing',
				},
				{
					title: 'Accenture B school challenge solution',
					link: 'https://drive.google.com/file/d/12H9bpojPPi-EXPkqB0pqdylO31DdMtf5/view?usp=sharing',
				},
				{
					title: 'Bajaj Finserv case problem statement',
					link: 'https://drive.google.com/file/d/1Nnu96DDs8auIF0fz92NAkvY7LUUjqaz8/view?usp=sharing',
				},
				{
					title: 'Bajaj Finserv national finale presentation',
					link: 'https://drive.google.com/file/d/1MqC0-6c0D8YLvv5kUHhEysjCUIPO7-er/view?usp=sharing',
				},
				{
					title: 'Diageo Bespirited problem statement',
					link: 'https://drive.google.com/file/d/1edegY6oHxEh5kQlXVgCUwRx5CrfrtkrL/view?usp=sharing',
				},
				{
					title: 'Diageo Bespirited national finale presentation',
					link: 'https://drive.google.com/file/d/1aHwvQwbqZYaYt_6Ijul7MxyMUFlGsHmJ/view?usp=sharing',
				},
				{
					title: 'Kotak screening round problem statement',
					link: 'https://drive.google.com/file/d/1bz02xzBRPUCN6N3Q6F0J7bjRegS4QJ5C/view?usp=sharing',
				},
				{
					title: 'Kotak screening round presentation',
					link: 'https://drive.google.com/file/d/1MrnfwR8EW9XAC_VZqEtv0dxahhv-V6FV/view?usp=sharing',
				},
				{
					title: 'Kotak national finale presentation',
					link: 'https://drive.google.com/file/d/1XFSmEDwe3xMh1ie6wyTRCQjyzUxtr88s/view?usp=sharing',
				},
				{
					title: 'Mario case problem statement',
					link: 'https://drive.google.com/file/d/11vSQaNXHvUQkD-PObAtOfHd5g0WbD8gW/view?usp=sharing',
				},
				{
					title: 'Marico case campus round submission',
					link: 'https://drive.google.com/file/d/16LNm4nZJy0UnYtNb2tud8H61CUfNDll7/view?usp=sharing',
				},
				{
					title: 'Marico case semi finals presentation',
					link: 'https://drive.google.com/file/d/18RJ-ZtYD0gQ6ilT-i5HXV6nXwsz0ny4Q/view?usp=sharing',
				},
				{
					title: 'Accenture B-school challenge- National Finalist',
					link: 'https://drive.google.com/file/d/186hqjVaKUhK4RyEMjf4xOiVnB708Kwsa/view?usp=sharing',
				},
				{
					title: 'Amazon advertising SMART challenge - National Winner',
					link: 'https://drive.google.com/file/d/105FtvsKSyqyosqfbpNhAwRVYhqXrd-Sr/view?usp=sharing',
				},
				{
					title: 'Loreal sustainability challenge - National Semi Finalist',
					link: 'https://drive.google.com/file/d/1_PWgon3BqruMp9bIEAB1QOKKhbUE44Yd/view?usp=sharing',
				},
				{
					title: 'Myntra StylBiz - National Semi Finalist',
					link: 'https://drive.google.com/file/d/1cryT3ViKxEgJipAuQTosLHejj5oLVIql/view?usp=sharing',
				},
				{
					title: 'Publicis Sapienet product spotlight - National Finalist',
					link: 'https://drive.google.com/file/d/1xc4_tM96Cg4zLNJ1UyvTPGI8dLNdfoQX/view?usp=sharing',
				},
				{
					title: 'Publicis Sapienet product spotlight National Finalist',
					link: 'https://drive.google.com/file/d/1JjK5Ku0ijdkS21-SYUkMrvBY3knEXy2F/view?usp=sharing',
				},
				{
					title: 'EV GTM case',
					link: 'https://drive.google.com/file/d/1lT9i_WgB1uuE2Jej2y7sken1K7Gg0yCk/view?usp=sharing',
				},
				{
					title: 'Gaming platform growth case',
					link: 'https://drive.google.com/file/d/1Gw84pkETGiRzWm5m5S_vTvH2P7zRZYYJ/view?usp=sharing',
				},
				{
					title: 'InsurTech platform pitchdeck',
					link: 'https://drive.google.com/file/d/1XpF5SmZOSFwBwcYtwbn8nz_wD6Ry96fV/view?usp=sharing',
				},
				{
					title: 'Luxury Brand M&A case',
					link: 'https://drive.google.com/file/d/1wHnbmbnsHxa0wRbC2y866AEI3OnqBmll/view?usp=sharing',
				},
				{
					title: 'Luxury Brand new idea case',
					link: 'https://drive.google.com/file/d/1wa44NQejju7fg4f7u-KLd_Ty36WKdl4l/view?usp=sharing',
				},
				{
					title: 'NeoBank GTM case',
					link: 'https://drive.google.com/file/d/1jubx_geDgzcIZg3GgNB0Cils18sqZ7jQ/view?usp=sharing',
				},
				{
					title: 'Public sector transformation case',
					link: 'https://drive.google.com/file/d/1j9O1sqXdXNfiqPrYCdCBKIsdgdt-Jf6Z/view?usp=sharing',
				},
				{
					title: 'Toy manufacturer profitability case',
					link: 'https://drive.google.com/file/d/1YiH-0tGCdaX_kLZPlzuwsS2PbJvv2AZ5/view?usp=sharing',
				},
				{
					title: 'Aura - Case competition deck',
					link: 'https://drive.google.com/file/d/1R77SFNkLXVFKvhZ0NOC0LXGY8X_Y3iAG/view?usp=sharing',
				},
				{
					title: 'Marico Over the wall ',
					link: 'https://drive.google.com/file/d/1rJSXg_hp2B2tZEqDTBn1JUd0haWm9RLj/view?usp=sharing',
				},
				{
					title: 'Bajaj Atom Presentation',
					link: 'https://drive.google.com/file/d/1H3woa5opXcueGMkiADLeIFwU36rzO8HS/view?usp=sharing',
				},
				{
					title: 'Dettol - reckitt global challenge',
					link: 'https://drive.google.com/file/d/1edGQztp6RB3DDP68R9yzupbltAH37Pnw/view?usp=sharing',
				},
				{
					title: 'Revamping Zara- A strategic Business proposal',
					link: 'https://drive.google.com/file/d/1YpXiwK6npKPFELNUJMgbysBBCEmPp9Yh/view?usp=sharing',
				},
				{
					title: 'Flipkart wired semi final',
					link: 'https://drive.google.com/file/d/1MXFEUJ84wedQxqzhdVxdw7iZUcGBNqlJ/view?usp=sharing',
				},
			],
			articles: [],
		},
	},
	{
		title: 'Guesstimate Guru: Mastering the Art of Estimation',
		content: {
			playlists: [
				{
					title: 'CIC: Learn the Basic Case Concepts',
					videos: [
						{
							title: '#1- Guesstimates',
							link: 'https://youtu.be/m0vNtHKRNaA',
						},
						
					],
				},
				{
					title: 'CIC: Guesstimate Mock Interview Videos',
					videos: [
						{
							title: '#1 McDonalds Guesstimate 1',
							link: 'https://youtu.be/4ttxod7nZbY',
						},
						{
							title: '#2 McDonalds Guesstimate 2',
							link: 'https://youtu.be/fJFvapYo3QU',
						},
						{
							title: '#3 Laptops Guesstimate 1',
							link: 'https://youtu.be/fPyI00hr1Tw',
						},
						{
							title: '#4 Laptops Guesstimate 2',
							link: 'https://youtu.be/sy2h0sRpVvA',
						},
					],
				},
				{
					title: 'Guesstimate Example Videos',
					videos: [
						{
							title: 'No. of trains in the Delhi metro network',
							link: 'https://youtu.be/7XFlVi6v4bU',
						},
						{
							title: 'No of flights out of Delhi in a day?',
							link: 'https://youtu.be/ILUWBewGes0',
						},
						{
							title: 'Area of India?',
							link: 'https://youtu.be/frWnS2fCoHw',
						},
						{
							title: 'Estimating the area of Delhi',
							link: 'https://youtu.be/SuIt-hGXNGs',
						},
					],
				},
			],
			pdfs: [
				{
					title: 'The Guesstimate examples',
					link: 'https://drive.google.com/file/d/1_XCEaujBto7dX62ol_qyXWgb0fBMiY0c/view?usp=sharing',
				},
				{
					title: 'Guesstimate Questions Set',
					link: 'https://drive.google.com/file/d/1ufnjK76dM0vE52YL7gcktqQ37d0S2S1i/view?usp=sharing',
				},
				{
					title: 'Guesstimate- Fleet size of Delhi Metro',
					link: 'https://drive.google.com/file/d/1RF9sjSzW-_CtU7LCJkBChnGpxC96Jyd9/view?usp=sharing',
				},
				{
					title: 'Guesstimate- Demand for Gold Flake Cigarettes',
					link: 'https://drive.google.com/file/d/1fdPHMG0VaiHr7S0WrUdnwNC4AK2fg5-Z/view?usp=sharing',
				},
				{
					title: 'Guesstimate- Quantity of Grapes exported from Nashik',
					link: 'https://drive.google.com/file/d/1zi9Bg0l9BAdDxgaRL6_ywgKoCfkkcQTA/view?usp=sharing',
				},
				{
					title: 'Guesstimate- Number of Toothbrushes in India',
					link: 'https://drive.google.com/file/d/1PI4Ie-TmxafnlgVPsM-Ooeuj_hzUnQ8X/view?usp=sharing',
				},
				{
					title: 'Guesstimate- Duration of ads streamed on YouTube daily',
					link: 'https://drive.google.com/file/d/1fJuV8Wk_WKemwG8OYhOP4d08pNfwUaKT/view?usp=sharing',
				},
				{
					title: 'Guesstimate- Tennis balls in Boeing 747',
					link: 'https://drive.google.com/file/d/1YrSuAOVzSLzhD2EsBimK2RDDWEf0DbK6/view?usp=sharing',
				},
				{
					title: 'Guesstimate- Market size of Driverless Cars',
					link: 'https://drive.google.com/file/d/1ppxt87lOmWVIbJub_aEZkRCf6tHcEmSX/view?usp=sharing',
				},
				{
					title: 'Guesstimate- Spectacles in Bangalore',
					link: 'https://drive.google.com/file/d/1ovDhoNJsZ2E_sxUMi9wTFQM1Of86SMth/view?usp=sharing',
				},
				{
					title: 'Guesstimate - Weight of Airplane',
					link: 'https://drive.google.com/file/d/13-otLeYMFhowZtbs4qH16ObVVFulBIrO/view?usp=sharing',
				},
				
			],
			articles: [],
		},
	},
	{
		title: 'The Secrets of Good Investing ',
		content: {
			playlists: [],
			pdfs: [],
			articles: [
				{
					title: '1. How is the value of the rupee decided with respect to the dollar?',
					img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhfS6RdFooVrLaEKc-OC69-FnD0RKkjMTHv3o987dAfpb8AbTqgb_57pSOc67dRlQRlRhq8fiI4MK7zqLlfY4y9H7_ikzpm-nrl6YUfB1q_SL1jips6Dqg5ckUTj4EaMURKOmbexlbcU4ZDhvVnesx_BTtEGbD69xhKJLsCn5DBhA_uzQsR6jvvArGv6w/w627-h343/122.png',
					src: 'https://secretsofgoodinvesting.blogspot.com/2022/06/1-how-is-value-of-rupee-decided-with.html',
				},
				{
					title: '2. What is the Fiscal Deficit and how it affects the economy?',
					img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiJ_DAvNftHLea6Q7rU4-pnbRudBjw5DPN4iXLNrj70b_qnhe-zetLzypdI94SWt1RzFE94-EWi-nmMMb-dSzBCCnIWLHYSwoUwuJ2S0j7PeubRGa9JDl5pzAKqajUVtHgyf7F1Pka0BRELoEo-P4OaJhpd7PpJXcmE3XDvrFVoMg977wmVNGdODWnR5g/w627-h226/11.png',
					src: 'https://secretsofgoodinvesting.blogspot.com/2022/06/2-what-is-fiscal-deficit-and-how-it.html',
				},
				{
					title: '3. What is a Trade WAR?',
					img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgxu3UONRm3SsGk3DCQHEcu3BNM437xeohdeY_p8Hc9SsEVAXmWTnDd-2x4RsQTLImGsGjsetP6Hhpob2GpJaq7AmnHXy4h7XRwQsT2GlhEXJzmA3kiDHZDomuQsFoHcFYhE-pI_obiW0PeNE3V0RLZc6OEJcr7YfK8RmmkuOW1wmBMJs-Eu3i-CipxRw/w639-h313/1.png',
					src: 'https://secretsofgoodinvesting.blogspot.com/2022/06/3-what-is-trade-war.html',
				},
				{
					title: '4. What is US Fed rate hike? And how could it affect India?',
					img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgc4tjExdjX-td7ca7sPXGJsRPsjdqmxCNRA4yiZtVJEXQT5z28tdWvFwOCbWT9GNgCIaYh2Ge8wgsJShPUbiiY0YJ0N0Sijgq20UTlYvQMO2tuI86MN2zroh-GjHH4p8v5bdF3HUW72KeYpph-APJ2AgTiCTguYJKc6b3Sku27kInI_aGjYcLFFwY5rw/w642-h343/10.png',
					src: 'https://secretsofgoodinvesting.blogspot.com/2022/06/4-what-is-us-fed-rate-hike-and-how.html',
				},
				{
					title: '5. How does a weak Indian Rupee vs. the US Dollar affect the Indian economy?',
					img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjTKQkqwxStwQO0p8qSBoVhj6K0K_RcG-rW8ZFLiJsKIOM5o8EOstEuk8H8X0qxgYdfh7cel3Of4mEYsJFw4m0PB4dc7FFMYJZ_eZJGvlN5euVN3Qz6pdoF_lV3S45Dz4CFOti8bAujPnPrYwo8ZW4q3CqIqbs2YgaMhKE9TmSgEVQ2E2XJd20XaQXUMg/w632-h286/1.png',
					src: 'https://secretsofgoodinvesting.blogspot.com/2022/06/5-how-does-weak-indian-rupee-vs-us.html',
				},
				{
					title: '6. How much debt does India has?',
					img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEharsAUNUoymYIcW9OxSCKaAJZfm1YDBzSPcDqLDABxaVm7EwWsGepQRJVJ8hbQeuGN2lxY_anwOHxBUz6oUE3oKt9TGdLwBS1wtRuxoea-l11Vz7JK7Kvc5j2HzHj8U86jleAC9mRmCFVcJrvwUiQiEH76D9oHr5k54Cz7EWZrA8OwF32Ra0Yeu4ScYQ/w633-h363/16.png',
					src: 'https://secretsofgoodinvesting.blogspot.com/2022/06/6-how-much-debt-does-india-has.html',
				},
				{
					title: '7. Why do Indian stock prices fall when oil prices rise?',
					img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEg0YvDT9G4qNithDAgnbppb-mVviBvwzYzefyRQe1F2_sasNLvsMWWLJHKl9784j6AniNF_uQ6U-SgilVE60-wcq0e7ep1-AP6DArC8_igorPmdfTlQZQTt_JWZlb6ZcWfMSSEcwGKnzciGYBXhLk9tqmyG-wKSLzBgGyK3JKeKxdyEEL2KPAWFlPQvJA/w634-h331/4.png',
					src: 'https://secretsofgoodinvesting.blogspot.com/2022/06/7-why-do-indian-stock-prices-fall-when.html',
				},
				{
					title: '8. Which factors should be considered while investing in the stock market?',
					img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjbc9vOz7XIpjmOTDfD34wIGsg0F1mX3IMnMpa7iGmKEbGAE6b8u_7efdPhQGq4XC_v4IeiRVsjAYyu2e_WS6uHbhV_dmcFrHYPnyhKkX3Ps_keX8wfh-oG-uLhAJMhuJExSh9lsRqRbX5B2AVV9QdwAyml9dshuXWKffSFx8Udikab73vIkpf0SBF8Rg/w641-h244/1.png',
					src: 'https://secretsofgoodinvesting.blogspot.com/2022/06/8-which-factors-should-be-considered.html',
				},
				{
					title: '9. How does a weaker currency lead to stronger exports?',
					img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgAs3X3EGGo2iOJyN8-H2T4a6ABZo4ClGwuWWYY7UoF1VAsVkYUYRs7funX9vpCRqnoiSVUnUneUjOeVS9HMmOmmQlQCKjr3GfcwaS_zzTCH6hlfOIZZme2vadORNtdpoglgTEPSoii9mwMR8Rwr9fEfMUFpb4JUch5oMQyTnofq12V5vfZW4AGeyblDA/w626-h301/12.png',
					src: 'https://secretsofgoodinvesting.blogspot.com/2022/06/9-how-does-weaker-currency-lead-to.html',
				},
				{
					title: '10. Two most efficient indicators that can help you to make profitable trades',
					img: 'https://blogger.googleusercontent.com/img/a/AVvXsEgUW_pW588hZA-tpeVriOWepIcft-icq5NqHQzXJruTllPxXei4yTCuNADorxf3rDzyV3nLL9F0YV_KNI4OL1htffZDoCg5Q42xj45_RWx9ZHEQm3OrEauA9ikVWTbSBQLUShnaC2C9zntcrGVG8eOHlyMD-NFyyTE1zdBwOYIag4ny3UPKTX2FaC8M5g=w636-h269',
					src: 'https://secretsofgoodinvesting.blogspot.com/2022/06/10-two-most-efficient-indicators-that.html',
				},
				{
					title: "11. The insolved mystery of 'Golden Ratio'",
					img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjXnPJAyM1TrLfAd3tycI6hCyIZDCuxjg7t7HckHONZ-CfY76lvYfdHri55YKq0thjxUz7OLWfMNNc8aL7rGZUHOBvms-W-VnV92Z5Ra2sEiDb16Z7oI3mjwDBJCIhxeAIeHoPxyywH8S4nr4ttbnm79oCuG_TcYD9yAGPS9rRitpxu6BxIwiUDOMPrhg/w627-h351/31.png',
					src: 'https://secretsofgoodinvesting.blogspot.com/2022/06/11-unsolved-mystery-of-golden-ratio.html',
				},
				{
					title: '12. Two magical tricks for Profitable Trades',
					img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEj8SqfPacw8Dd1Ti6xViNGw1CfwfeM2FgtRZ77OjZZBbCGuomU7pmYzEY385ENZxUNejNHP2tYFmq53-OT8dmf04GQAiwJwR9nv0UqCcDW7Amp3N-GkGShTCQYxEvz8IKeRBWJj2xW14u0A1dJcQtnykT97_VQfiM8oYkcOxMVQP9uWovPuByifz4qeCQ/w638-h329/2.png',
					src: 'https://secretsofgoodinvesting.blogspot.com/2022/05/12-two-magical-tricks-for-profitable.html',
				},
				{
					title: '13. When is the best time to buy a stock?/',
					img: 'https://blogger.googleusercontent.com/img/a/AVvXsEjXPRskP2-B_gQMDqZGS1pCzzq1BteHcIaL5LdFG_pDjeY0H4j9GOAZjKjJNooflTkb__rpCp4CYHZGAgNT9pu-jWk7CzY7LOSRqBheKPHvtOSoHq_tluyK5J8MDMNl089WATKKjWK5oIBEq1A-H39Lj5rcNkngwot84NbimJw6bllmfuFuvAEjXuAhRg=w641-h444',
					src: 'https://secretsofgoodinvesting.blogspot.com/2022/05/13-when-is-best-time-to-buy-stock.html',
				},
				{
					title: '14. How do professional stock market analysts analyse stocks?',
					img: 'https://blogger.googleusercontent.com/img/a/AVvXsEjLkfU01SpuH_Q5FT2er3Bt7PxZEf7CGVZUNANeMAF2vi49DY6DqMCyUvoD65R_60jPKAsY24Hc05EKT55uJoc9tXgYN9fyPiBOjYMsUIgagW9iAP470hmqqMBh4EiEfnXhvIQpaYtG2GgPtkItZAirt5X8wQWl6s3DGZif_l-dhFUkPiZsXo6qqiDuyw=w638-h354',
					src: 'https://secretsofgoodinvesting.blogspot.com/2022/05/14-how-do-professional-stock-market.html',
				},
				{
					title: "15. '2008 Financial Crisis', How it actually happened?",
					img: 'https://blogger.googleusercontent.com/img/a/AVvXsEheECeJvjCXft5io_pn0SJ0KP92hLtLuXuI2zi3T_2H-pdrtw3vTt4ILsBqvPUaAdYi6THTIhVE9gxI9W-EHN7iPcH2J0jW79xcAB1kw1hGIJUMis3j1GlADvjQo0cqVbJg-BHd3zDqFRadz3rixzD5yxKrEMx1UIJhAi6iX3sH_OPFXbPNcSTXG1HCbg=w642-h362',
					src: 'https://secretsofgoodinvesting.blogspot.com/2022/05/14-2008-financial-crisis-how-it.html',
				},
				{
					title: '16. Oracle of Omaha',
					img: 'https://blogger.googleusercontent.com/img/a/AVvXsEhmo3v1T39BXBRFZvUAWnr_QE3x8W8ad9OUhebqq_y7yCm7zTJzK98wUeM2ioLygc0BKvgzG8H9WRnBY0ji9dloLvlptAIjHhJcaPLKmgjmP-_5gjF4cJqCEKZJYLBAjSTG4IMfk3csY1bwpqJiLH_FsjS6GDbALexXoaqh3s8pBfBCBuin5TbmvVSShg=w633-h302',
					src: 'https://secretsofgoodinvesting.blogspot.com/2022/05/16-oracle-of-omaha.html',
				},
			],
		},
	},
];
